"use client";

import { useContent } from "../../content/current";
import LegalContent from "./LegalContent";

export default function CookiesContent() {
  const content = useContent();
  return <LegalContent html={content.legalPages.cookies.html} />;
}
